import { PlaywrightProxyMessage } from './playwright-proxy-client.js';
export type { PlaywrightProxyMessage };

export const handlePlaywrightMessage = async (api: any, message: PlaywrightProxyMessage): Promise<any> => {
  // Helper to execute chain
  const executeChain = async (root: any, chain: any[]) => {
    let current = root;
    for (const link of chain) {
      if (typeof (current as any)[link.method] !== 'function') {
         throw new Error(`Method ${link.method} not found on object`);
      }
      current = await (current as any)[link.method](...link.args);
    }
    return current;
  };

  if (message.type === 'chain-call' && message.chain) {
    return executeChain(api, message.chain);
  }
  
  if (message.type === 'page-call' && message.method) {
    let target = api;
    if (message.scope) {
       target = (api as any)[message.scope];
       if (!target) throw new Error(`Scope ${message.scope} not found on api`);
    }
    if (typeof (target as any)[message.method] !== 'function') {
       throw new Error(`Method ${message.method} not found on target`);
    }
    return (target as any)[message.method](...(message.args || []));
  }
  
  throw new Error(`Unknown proxy message type: ${message.type}`);
};
